import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;

  .container {
    display: flex;
    flex-direction: column;
    font-family: Ubuntu, sans-serif;
    width: 100%;
  }

  .dropzone {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 24px;
    border-width: 2px;
    border-radius: 8px;
    border-color: #717171;
    border-style: dashed;
    background-color: #f0f9fb;
    color: #6e6e6e;
    outline: none;
    transition: border 0.24s ease-in-out;

    .info {
      max-width: 600px;
      margin: auto;
      padding: 0 24px;

      h4 {
        margin: 0;
      }

      p {
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        letter-spacing: 0.02em;
      }
    }
  }

  .dropzone:focus {
    border-color: #12a3bb;
  }

  .dropzone.disabled {
    opacity: 0.6;
  }
`

export const focusedStyle = {
  borderColor: '#12a3bb',
}

export const acceptStyle = {
  borderColor: '#2f6b50',
  backgroundColor: '#f0fbf6',
}

export const rejectStyle = {
  borderColor: '#ff1744',
  backgroundColor: '#fbf0f0',
}
